import cookie from '@boiseitguru/cookie-cutter';

export const getDeviceId = async () => {
  try {
    return cookie.get('hardwareId') || (await WebEmarsysSdk.getClientId());
  } catch (error) {
    console.log(error);
    return null;
  }
};
